import script from "./HomeIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeIndex.vue?vue&type=script&setup=true&lang=js"

import "./HomeIndex.vue?vue&type=style&index=0&id=29d01f28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29d01f28"]])

export default __exports__